import { Badge } from '@shopify/polaris';
import { DataTableRow } from '../../../shared/components/DataTable';
import { WebhookLogRecord } from './api';

function formatDate(d: string | null): string {
  if (!d) return '—';
  return new Date(d).toLocaleString();
}

export function webhookLogToRow(log: WebhookLogRecord): DataTableRow {
  return {
    id: log.id,
    cells: [
      log.topic,
      log.shopDomain,
      log.shopifyOrderId ?? '—',
      formatDate(log.receivedAt),
      formatDate(log.processedAt),
      log.error ? <Badge tone="critical" key="err">Error</Badge> : <Badge tone="success" key="ok">OK</Badge>,
    ],
  };
}
